import React, { useState, useRef } from 'react'
import './Navbar.css'
import underline from './assets/nav_underline.svg'
import AnchorLink from 'react-anchor-link-smooth-scroll';
import menu_open from './assets/menu_open.svg'
import menu_close from './assets/menu_close.svg'

const Navbar = () => {
  const [menu,setMenu] = useState("Introduction");

  const menuRef = useRef();
  
  const openMenu= ()=>{
    menuRef.current.style.right="0";
  }
  const closeMenu= ()=>{
    menuRef.current.style.right="-350px";
  }
  return (
    <div className='navbar'>
      <img className='nav-img' src="https://png.pngtree.com/png-clipart/20230313/original/pngtree-raghav-png-image_8986801.png" alt="Logo" />
      <img src={menu_open} onClick={openMenu} alt="" className='nav-mob-open' />
      <ul ref={menuRef} className='nav-menu'>
        <img src={menu_close} onClick={closeMenu} alt="" className="nav-mob-close" />
      <li><AnchorLink className='anchor-link' href='#Intro'> <p onClick={()=>setMenu("Introduction")}> Introduction </p></AnchorLink>{menu==="Introduction"? <img src={underline} alt=''/>:<></>} </li>
      <li><AnchorLink className='anchor-link' offset={50} href='#Education'> <p onClick={()=>setMenu("Education")}> Education Qualification </p></AnchorLink>{menu==="Education"? <img src={underline} alt=''/>:<></>} </li>
      <li><AnchorLink className='anchor-link' offset={50} href='#Project'> <p onClick={()=>setMenu("Projects")}> Projects </p></AnchorLink>{menu==="Projects"? <img src={underline}alt=''/>:<></>} </li>
      <li><AnchorLink className='anchor-link' offset={50} href='#Services'> <p onClick={()=>setMenu("Services")}> Services </p></AnchorLink>{menu==="Services"? <img src={underline}alt=''/>:<></>} </li>
      <li><AnchorLink className='anchor-link' offset={50} href='#Contact'> <p onClick={()=>setMenu("Contact")}> Contact </p></AnchorLink>{menu==="Contact"? <img src={underline}alt=''/>:<></>} </li>
      </ul>
      <div className='nav-connect'><AnchorLink className='anchor-but' offset={50} href='#Contact'>Connect With Me</AnchorLink></div>
    </div>
  )
}
export default Navbar

